module.exports = __webpack_public_path__ + "static/media/09.07d8023c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/09.jpg
// module id = 571
// module chunks = 0